// Next index after `current` (wrapping) that is not in `broken`; returns
// `current` when every index is broken.
export const nextUsableIndex = (current, length, broken) => {
  for (let step = 1; step <= length; step++) {
    const candidate = (current + step) % length;
    if (!broken.has(candidate)) return candidate;
  }
  return current;
};
